// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"21b5aa76","428":"34fd32e2","838":"54b1e3b6","894":"7fcba09c"}[chunkId] + ".chunk.js";
};